import { useTranslation } from "react-i18next";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { IListItem } from "./types";
import ConsumerModal from "../../yoello-lib/modules/components/Layouts/ConsumerDetailsListLayout/ConsumerModal"
import { ICustomer } from "../../yoello-lib/modules/components/Layouts/ConsumerDetailsListLayout/ConsumerModal"
import { IMultiDialogChildren } from "../dialogRoutes/MultiDialogRoute";
import { useDialogSetup } from "../dialogRoutes/useDialogSetup";
import { FormLoadingWrapper } from "../util/FormLoadingWrapper";
import ListLoading from "../util/Loading";

interface ICustomerFormDialog extends IMultiDialogChildren {
  venueId: string;
  customerData: IListItem;
  history: any;
  routePath: string;
  id: string;
}

export function CustomerDialog(props: ICustomerFormDialog) {
  const {
    routePath,
    id,
    dialogKey,
    venueId
  } = props;

  const { t } = useTranslation();
  const { callAPI, apiData } = useAPIV2<ICustomer>(
    APIExtensions.customersDetails,
    {
      onMountDisabled: true,
    },
  );
  const { goToNextStep, formData: customerData, isLoading } = useDialogSetup(props, callAPI, "customerData", {
    doNotCacheValue: true,
    errorCall: t("api.call.error"),
    query: `${id}/orders`,
    yoelloAPIParams: { venue_id: venueId, size:200 },
    isPaginated:true
  }, true);

  function onSelectItem(orderID: string) {
    goToNextStep(
      "order", {
      ComponentProps: {
        orderID,
      }
    },
      `${routePath}/orders/${orderID}`,
      dialogKey
    );
  }
  if (isLoading || !apiData) return <FormLoadingWrapper padding='5rem 10rem'><ListLoading/></FormLoadingWrapper>
  return <ConsumerModal data={customerData} onSelectItem={onSelectItem} />
}
